import React from "react";

const HouseIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
         stroke={props.stroke ? props.stroke : 'currentColor'}
         strokeWidth={props.strokeWidth ? props.strokeWidth : 2} strokeLinecap="round" strokeLinejoin="round"
    >
        <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"/>
        <path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    </svg>
);

export default HouseIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/HouseIcon.jsx